module.exports = __webpack_public_path__ + "img/4.13175c9c.png";